import { FaInfoCircle } from "react-icons/fa";
import { useState } from "react";
import PdfViewerModal from "../../../features/reports/components/PdfViewerModal/PdfViewerModal";

function CiudadanoCertificados() {
    const [openPdf, setOpenPdf] = useState(false);

    return (
        <div className="rounded-[var(--radius-md)] bg-white p-[25px] shadow-[0_5px_15px_rgba(0,0,0,0.08)]">
            <h3 className="mb-5 text-lg font-semibold text-primary">Últimos Certificados</h3>

            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Folio</th>
                            <th>Tipo</th>
                            <th>Fecha</th>
                            <th>Estado</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>CER-0001</td>
                            <td>Ciudadano</td>
                            <td>14/07/2026</td>
                            <td>
                                <span className="rounded-full bg-success-bg px-[10px] py-[5px] text-xs font-semibold text-success">
                                    Vigente
                                </span>
                            </td>
                            <td>
                                <button
                                    className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg border-none bg-info-bg text-primary transition-colors hover:bg-primary hover:text-white"
                                    onClick={() => setOpenPdf(true)}
                                >
                                    <FaInfoCircle />
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td>CER-0002</td>
                            <td>Patrimonial</td>
                            <td>13/07/2026</td>
                            <td>
                                <span className="rounded-full bg-warning-bg px-[10px] py-[5px] text-xs font-semibold text-warning">
                                    Validando
                                </span>
                            </td>
                            <td>
                                <button className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg border-none bg-info-bg text-primary transition-colors hover:bg-primary hover:text-white">
                                    <FaInfoCircle />
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <PdfViewerModal
                open={openPdf}
                onClose={() => setOpenPdf(false)}
                pdfUrl="/pdfs/ciudadano.pdf"
            />
        </div>
    );
}

export default CiudadanoCertificados;
